import { cn } from "@/lib/utils";

const FormSectionHeader = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className="flex items-start mb-6">
      <h4 className={cn("font-[500] text-[16px] text-start", className)}>
        {children}
      </h4>
    </div>
  );
};

export default FormSectionHeader;
